<script setup lang="ts">

import {onMounted,} from "vue";
import type {EnrollmentDraftResponse} from "../../../responses/Site/EnrollmentDraftResponse.ts";
import {useEnrollmentStore} from "../../stores/enrollment.ts";
import Skeleton from "../Skeleton.vue";
import EnrollmentHeader from "./EnrollmentHeader.vue";
import Step1 from "./Step-1.vue";
import Step2 from "./Step-2.vue";
import Step3 from "./Step-3.vue";

interface Props {
    enrollment: EnrollmentDraftResponse,
    step: string|null,
    backUrl?: string|null,
}

const props = withDefaults(defineProps<Props>(), {})
const store = useEnrollmentStore();

onMounted(() => {
    store.init(props.enrollment);
    store.startOpened(props.step);
});

</script>

<template>
    <section class="bg-white py-10 lg:py-16">
        <div class="container mx-auto px-4 max-w-5xl" v-if="store.enrollment" >

            <EnrollmentHeader :back-url="backUrl"></EnrollmentHeader>

            <div class="mt-8">
                <Step-1 id="step_1" ></Step-1>
                <div class="border-b text-gray-800"></div>
                <Step-2 id="step_2"></Step-2>
                <div class="border-b text-gray-800"></div>
                <Step-3 id="step_3"></Step-3>
            </div>
        </div>
        <div v-else>
            <div class="py-6">
                <div class="flex items-center space-x-4 px-4 py-6 sm:px-6" v-for="n in 3" :key="n">
                    <Skeleton class="h-64 container bg-gray-200  rounded-lg grid grid-cols-2 gap-4 p-6">
                        <Skeleton class="h-8 bg-gray-300" v-for="n in 6" :key="n" />
                    </Skeleton>
                </div>
            </div>
        </div>
    </section>
</template>
